module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Chart.js"));
	}, "chartjs");
}